import { render, staticRenderFns } from "./ThematicsFilter.vue?vue&type=template&id=22ab82f6"
import script from "./ThematicsFilter.vue?vue&type=script&lang=js"
export * from "./ThematicsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports